(() => {
  'use strict';

  if (window.__rdHomePassionTabsRegistered) return;


  const register = () => {
    if (
      !window.RD?.register ||
      window.__rdHomePassionTabsRegistered
    ) {
      return;
    }

    window.__rdHomePassionTabsRegistered = true;


    window.RD.register(
      'passion-tabs',
      (root) => {

        const tabs = Array.from(
          root.querySelectorAll(
            '[data-rd-passion-tab]'
          )
        );

        const panels = Array.from(
          root.querySelectorAll(
            '[data-rd-passion-panel]'
          )
        );

        const tabList =
          root.querySelector(
            '.rd-passion__tabs'
          );


        if (
          tabs.length <= 1 ||
          panels.length === 0
        ) {
          return;
        }


        const mobileQuery =
          window.matchMedia(
            '(max-width: 749px)'
          );

        const reducedMotionQuery =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );


        const autoplayEnabled =
          root.dataset.rdMobileAutoplay !==
          'false';

        const autoplayDelay =
          Math.max(
            2000,
            Number.parseInt(
              root.dataset
                .rdMobileAutoplayDelay ||
                '3500',
              10
            ) || 3500
          );


        const storageKey =
          `rd_passion_active_${root.id}`;


        let autoplayTimer = 0;
        let inView = true;
        let observer = null;


        const getPanel = (id) =>
          panels.find(
            (panel) =>
              panel.dataset
                .rdPassionPanel === id
          );


        const readStoredTab = () => {
          if (!window.Shopify?.designMode) {
            return '';
          }

          try {
            return (
              sessionStorage.getItem(
                storageKey
              ) || ''
            );
          } catch (_) {
            return '';
          }
        };


        const storeActiveTab = (id) => {
          if (
            !window.Shopify?.designMode ||
            !id
          ) {
            return;
          }

          try {
            sessionStorage.setItem(
              storageKey,
              id
            );
          } catch (_) {
            /* sessionStorage may be unavailable */
          }
        };


        const hydrate = (panel) => {
          if (
            !panel ||
            panel.dataset.rdHydrated ===
              'true'
          ) {
            return;
          }


          const template =
            panel.querySelector(
              ':scope > [data-rd-passion-template]'
            );


          if (
            template instanceof
            HTMLTemplateElement
          ) {
            panel.appendChild(
              template.content.cloneNode(
                true
              )
            );

            template.remove();
          }


          panel.dataset.rdHydrated =
            'true';
        };


        const centerTab = (tab) => {
          if (
            !tabList ||
            !tab
          ) {
            return;
          }


          const left =
            tab.offsetLeft -
            (
              tabList.clientWidth -
              tab.offsetWidth
            ) / 2;


          tabList.scrollTo({
            left: Math.max(
              0,
              left
            ),

            behavior:
              reducedMotionQuery.matches
                ? 'auto'
                : 'smooth'
          });
        };


        const activate = (
          id,
          options = {}
        ) => {

          const targetTab =
            tabs.find(
              (tab) =>
                tab.dataset
                  .rdPassionTab === id
            );


          const targetPanel =
            getPanel(id);


          if (
            !targetTab ||
            !targetPanel
          ) {
            return;
          }


          hydrate(targetPanel);


          tabs.forEach((tab) => {
            const active =
              tab === targetTab;


            tab.classList.toggle(
              'is-active',
              active
            );


            tab.setAttribute(
              'aria-selected',
              String(active)
            );


            tab.tabIndex =
              active ? 0 : -1;
          });


          panels.forEach((panel) => {
            panel.hidden =
              panel !== targetPanel;
          });


          storeActiveTab(id);


          if (options.focus) {
            targetTab.focus({
              preventScroll: true
            });
          }


          if (options.scroll) {
            centerTab(
              targetTab
            );
          }
        };


        const getActiveIndex = () => {
          const index =
            tabs.findIndex(
              (tab) =>
                tab.classList.contains(
                  'is-active'
                )
            );


          return index >= 0
            ? index
            : 0;
        };


        const canAutoplay = () =>
          autoplayEnabled &&
          mobileQuery.matches &&
          !reducedMotionQuery.matches &&
          !window.Shopify?.designMode &&
          !document.hidden &&
          inView;


        const stopAutoplay = () => {
          if (!autoplayTimer) return;


          window.clearInterval(
            autoplayTimer
          );


          autoplayTimer = 0;
        };


        const startAutoplay = () => {
          stopAutoplay();


          if (!canAutoplay()) return;


          autoplayTimer =
            window.setInterval(
              () => {

                const nextIndex =
                  (
                    getActiveIndex() +
                    1
                  ) %
                  tabs.length;


                activate(
                  tabs[nextIndex]
                    .dataset
                    .rdPassionTab,
                  {
                    scroll: true
                  }
                );

              },
              autoplayDelay
            );
        };


        const restartAutoplay = () => {
          stopAutoplay();
          startAutoplay();
        };


        const onClick = (event) => {

          const tab =
            event.target.closest(
              '[data-rd-passion-tab]'
            );


          if (
            !tab ||
            !root.contains(tab)
          ) {
            return;
          }


          activate(
            tab.dataset
              .rdPassionTab,
            {
              scroll:
                mobileQuery.matches
            }
          );


          restartAutoplay();
        };


        const onKeyDown = (event) => {

          const tab =
            event.target.closest(
              '[data-rd-passion-tab]'
            );


          if (
            !tab ||
            !root.contains(tab)
          ) {
            return;
          }


          const keys = [
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
          ];


          if (
            !keys.includes(
              event.key
            )
          ) {
            return;
          }


          event.preventDefault();


          const currentIndex =
            tabs.indexOf(tab);


          let nextIndex =
            currentIndex;


          if (
            event.key ===
            'ArrowRight'
          ) {
            nextIndex =
              (
                currentIndex +
                1
              ) %
              tabs.length;
          }


          else if (
            event.key ===
            'ArrowLeft'
          ) {
            nextIndex =
              (
                currentIndex -
                1 +
                tabs.length
              ) %
              tabs.length;
          }


          else if (
            event.key ===
            'Home'
          ) {
            nextIndex = 0;
          }


          else if (
            event.key ===
            'End'
          ) {
            nextIndex =
              tabs.length - 1;
          }


          activate(
            tabs[nextIndex]
              .dataset
              .rdPassionTab,
            {
              focus: true,
              scroll: true
            }
          );


          restartAutoplay();
        };


        const onBlockSelect = (
          event
        ) => {

          const blockId =
            event.detail?.blockId;


          if (!blockId) return;


          const tab =
            tabs.find(
              (item) =>
                item.dataset
                  .rdPassionTab ===
                blockId
            );


          if (!tab) return;


          activate(
            blockId,
            {
              scroll: true
            }
          );


          stopAutoplay();
        };


        const onVisibilityChange =
          () => {

            if (document.hidden) {
              stopAutoplay();
            } else {
              startAutoplay();
            }

          };


        const onMediaChange = () => {
          startAutoplay();
        };


        root.addEventListener(
          'click',
          onClick
        );


        root.addEventListener(
          'keydown',
          onKeyDown
        );


        document.addEventListener(
          'shopify:block:select',
          onBlockSelect
        );


        document.addEventListener(
          'visibilitychange',
          onVisibilityChange
        );


        mobileQuery
          .addEventListener?.(
            'change',
            onMediaChange
          );


        reducedMotionQuery
          .addEventListener?.(
            'change',
            onMediaChange
          );


        /*
          The first panel is already live DOM on storefront.
          In Theme Editor every panel is live DOM.
        */
        panels.forEach(
          (panel, index) => {

            const hasTemplate =
              Boolean(
                panel.querySelector(
                  ':scope > [data-rd-passion-template]'
                )
              );


            if (
              index === 0 ||
              !hasTemplate
            ) {
              panel.dataset
                .rdHydrated = 'true';
            }

          }
        );


        /*
          Restore the editor-selected tab after Shopify rerenders
          the section. This prevents a collection/product source
          change on tab 2/3 from visually jumping back to tab 1.
        */
        const storedTab =
          readStoredTab();


        const initialTab =
          tabs.find(
            (tab) =>
              tab.dataset
                .rdPassionTab ===
              storedTab
          ) ||
          tabs[0];


        if (initialTab) {
          activate(
            initialTab.dataset
              .rdPassionTab,
            {
              scroll: false
            }
          );
        }


        if (
          'IntersectionObserver'
          in window
        ) {

          observer =
            new IntersectionObserver(
              (entries) => {

                const entry =
                  entries[0];


                inView =
                  Boolean(
                    entry
                      ?.isIntersecting
                  );


                if (inView) {
                  startAutoplay();
                } else {
                  stopAutoplay();
                }

              },
              {
                threshold: 0.2
              }
            );


          observer.observe(root);

        } else {

          startAutoplay();

        }


        return () => {

          stopAutoplay();


          observer?.disconnect();


          root.removeEventListener(
            'click',
            onClick
          );


          root.removeEventListener(
            'keydown',
            onKeyDown
          );


          document.removeEventListener(
            'shopify:block:select',
            onBlockSelect
          );


          document.removeEventListener(
            'visibilitychange',
            onVisibilityChange
          );


          mobileQuery
            .removeEventListener?.(
              'change',
              onMediaChange
            );


          reducedMotionQuery
            .removeEventListener?.(
              'change',
              onMediaChange
            );

        };

      }
    );
  };


  if (window.RD?.register) {

    register();

  } else {

    document.addEventListener(
      'DOMContentLoaded',
      register,
      {
        once: true
      }
    );

  }

})();
